import './userNotes.css';
import { Button, CircularProgress, IconButton, TextField } from '@mui/material';
import pencilIcon from '../../../../img/pencil-icon.svg';
import cancelIcon from '../../../../img/close-icon-button.svg';
import { useState } from 'react';
import { useEditUserMutation } from '../../../../services/accountsApi';
import { useEffect } from 'react';

const UserNotes = ({user}) => {

  const [canEdit, setCanEdit] = useState(false);
  const [note, setNote] = useState(user.notes);
  const [error, setError] = useState(null)
  const [editUser,{ data, isLoading,isFetching }] = useEditUserMutation();

  function handleNoteChange(e) {
    // validation for max characters ( set in DB : 4000)
    if(e.target.value!==null && e.target.value.length >= 4000) {
      setError("You have reached the maximun number of characters (4000)")
    }else{
      setError(null)
    }
    setNote(e.target.value)
  }

  function handleSave() {
    let updatedUser = {...user, notes: note}
    console.log("UserNotes, user to update:", updatedUser)
    try {
      editUser(updatedUser)
    } catch (error) {
      console.log("UserNotes, error updating user:", error)
    }
  }

  function handleIconCLick() {    
    if(canEdit) {
      // reset note on cancel icon click
      setNote(user.notes)
    }
    setCanEdit(prev => !prev)
    // clean error message on reset
    setError(null)
  }

  useEffect(() => {
    console.log("data has changed:", data)
    if(data?.id) {
      console.log("UserNotes, user updated:", data)
    }
  }, [data])
  

  return (
    <div className='user-notes-container'>

      <div className="user-notes-header-container">
        <h3>Notes</h3>
        <IconButton name="buyingEmailsNoteEdit" className="buyingEmailsNoteEdit" onClick={handleIconCLick}>
          <img src={ canEdit ? cancelIcon : pencilIcon } alt="pencil" width="24px" height="24px" />
        </IconButton>
      </div>  
      <TextField 
        className="editNote"
        name="editNote"
        value={note}
        onChange={handleNoteChange}
        disabled={!canEdit}
        sx={canEdit&&{backgroundColor: 'white'}}
        variant='outlined'
        multiline={true}
        minRows={12}
        maxRows={12}
        fullWidth={true}
        error={error!==null}
        helperText={error}
      />
    <div className="user-notes-button-container">
      <Button sx={{width:"100px"}} variant='contained' disabled={ error !== null || isLoading || !canEdit} onClick={handleSave} >
        {
          isLoading || isFetching? <CircularProgress size="1.75em"/>: "Save"
        }
      </Button>
    </div>
    
    </div>
  );
}
 
export default UserNotes;